import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faCog,
  faPencilAlt,
  faTrashAlt,
  faMap,
  faPlus,
  faPaperPlane,
  faCircleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { B2Form, B2InputGroup } from "@hdb/biome-2";
import { FormControl } from "react-bootstrap";
import { ConfigurationStatusIndicator } from "../../general-configuration/components/configuration-status.component";
import zones_icon from "src/assets/images/zones-icon.png";
import NewPaginationComponent from "src/core/components/pagination/new-pagination.component";
import SkeletonComponent from "src/shared/custom-spinner/skeleton.component";
import type { AsyncStatus, Zone } from "../../components/types";

type ZoneCardListProps = {
  zones: Zone[];
  onEdit: (zone: Zone) => void;
  onDelete: (zone: Zone) => void;
  onSettings: (zone: Zone) => void;
  onNavigate: (zone: Zone) => void;
  onSendToGateway: (zone: Zone) => void;
  onViewAssets: (zone: Zone) => void;
  /*
  onSendSelectedToGateway: () => void;
  selectedZoneIds: number[];
  onZoneSelectionChange: (zoneId: number, isSelected: boolean) => void;
  */
  onUnacknowledgedClick: (zone: Zone) => void;
  /*
  onGroupUnacknowledgedClick: () => void;
  groupZoneStatus: { color: string; clickable: boolean } | null;
  groupZoneStatusTitle: string;
  */
  zoneAckInfoByZone: Record<string, any>;
  isLoading: boolean;
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
  onPageChange: (page: number) => void;
  zoneCount: number;
  onAddZone: () => void;
  searchText: string;
  onSearchTextChange: (searchText: string) => void;
  zoneConfigurationStates: Record<number, { status: AsyncStatus; countdown: number }>;
};

type ZonesToolbarProps = Pick<
  ZoneCardListProps,
  "zoneCount" | "onAddZone" | "searchText" | "onSearchTextChange"
>;

/*
type ZonesToolbarActionsProps = Pick<
  ZoneCardListProps,
  "groupZoneStatus" | "groupZoneStatusTitle" | "onGroupUnacknowledgedClick" | "onSendSelectedToGateway"
> & {
  selectedZoneCount: number;
};
*/

function ZonesToolbar({
  zoneCount,
  onAddZone,
  searchText,
  onSearchTextChange,
}: ZonesToolbarProps) {
  /* const isEmpty = zoneCount === 0; */

  return (
    <div className="zones-toolbar">
      <div className="zones-toolbar__left">
        <span className="zones-toolbar__icon">
          <FontAwesomeIcon icon={faMap} />
        </span>
        <span className="zone-header-text">Zones</span>
        <span className="zones-toolbar__badge">{zoneCount}</span>
      </div>
      <div className="zones-toolbar__search-wrap">
        <B2Form onSubmit={(event: any) => event.preventDefault()}>
          <B2InputGroup className="zones-toolbar__search">
            <B2InputGroup.Text>
              <FontAwesomeIcon icon={faSearch} />
            </B2InputGroup.Text>
            <FormControl
              placeholder="Search zones..."
              aria-label="Search zones"
              value={searchText}
              onChange={(event) => onSearchTextChange(event.target.value)}
            />
          </B2InputGroup>
        </B2Form>
      </div>
      <div className="zones-toolbar__actions">
        {/* {!isEmpty && (
          <>
            <button
              type="button"
              className="zones-toolbar__icon-btn zones-toolbar__icon-btn--primary"
              title={selectedZoneCount > 0 ? `Send ${selectedZoneCount} selected zones to gateway` : "Select zones to send to gateway"}
              aria-label="Send selected zones to gateway"
              onClick={onSendSelectedToGateway}
              disabled={selectedZoneCount === 0}
            >
              <FontAwesomeIcon icon={faPaperPlane} />
            </button>
            {groupZoneStatus && (
              <button
                type="button"
                className="configuration-icon-btn"
                title={groupZoneStatusTitle}
                style={{ color: groupZoneStatus.color }}
                onClick={groupZoneStatus.clickable ? onGroupUnacknowledgedClick : undefined}
              >
                <FontAwesomeIcon
                  icon={faCircleExclamation}
                  className={groupZoneStatus.clickable ? "cursor-pointer" : ""}
                  style={{ color: groupZoneStatus.color }}
                />
              </button>
            )}
            <span className="zones-toolbar__divider" />
          </>
        )} */}
        <span className="zones-toolbar__divider" />
        <button type="button" className="configuration-button configuration-button--primary" onClick={onAddZone}>
          <FontAwesomeIcon icon={faPlus} />
          Add Zone
        </button>
      </div>
    </div>
  );
}

export function ZoneCardList({
  zones,
  onEdit,
  onDelete,
  onSettings,
  onNavigate,
  onSendToGateway,
  onViewAssets,
  /*
  onSendSelectedToGateway,
  selectedZoneIds,
  onZoneSelectionChange,
  */
  onUnacknowledgedClick,
  /* onGroupUnacknowledgedClick, */
  zoneAckInfoByZone,
  /*
  groupZoneStatus,
  groupZoneStatusTitle,
  */
  isLoading,
  pageNumber,
  pageSize,
  totalRecords,
  onPageChange,
  zoneCount,
  onAddZone,
  searchText,
  onSearchTextChange,
  zoneConfigurationStates,
}: ZoneCardListProps) {
  const isEmpty = !isLoading && zones.length === 0;

  return (
    <div className="zones-list">
      <ZonesToolbar
        zoneCount={zoneCount}
        onAddZone={onAddZone}
        searchText={searchText}
        onSearchTextChange={onSearchTextChange}
        /* groupZoneStatus={groupZoneStatus}
        groupZoneStatusTitle={groupZoneStatusTitle}
        onGroupUnacknowledgedClick={onGroupUnacknowledgedClick}
        onSendSelectedToGateway={onSendSelectedToGateway}
        selectedZoneCount={selectedZoneIds.length} */
      />

      <SkeletonComponent
        wrapperHeight="340px"
        skeletonHeight="60px"
        count={5}
        isLoading={isLoading}
        isShowCardStyle={false}
      >
        {isEmpty ? (
          <div className="zones-empty">
            <div className="zones-empty__icon">📍</div>
            <div className="zones-empty__title">No zones found</div>
            <div className="zones-empty__subtitle">
              Get started by adding a new zone for this asset.
            </div>
          </div>
        ) : (
          <>
            <div className="zone-cards-list">
              {zones.map((zone) => (
                <div key={zone.id} className="zone-card">
                  {/* <label className="zone-card__selection">
                    <input
                      type="checkbox"
                      checked={selectedZoneIds.includes(zone.id)}
                      onChange={(event) => onZoneSelectionChange(zone.id, event.target.checked)}
                      aria-label={`Select ${zone.name}`}
                    />
                  </label> */}
                  <div className="zone-card__logo">
                    <img src={zones_icon} alt="Zone" />
                  </div>
                  <button
                    type="button"
                    className="zone-card__info zone-card__info--button"
                    onClick={() => onViewAssets(zone)}
                    aria-label={`View assets in ${zone.name}`}
                    title="View zone assets"
                  >
                    <div>
                      <div className="zone-card__title">{zone.name}</div>
                      <div className="zone-card__meta">Zone Id: {zone.zoneId}</div>
                    </div>
                  </button>
                  <div className="zone-card__actions">
                    <button
                      type="button"
                      className="zone-card__action zone-card__action--navigate"
                      title="Send to gateway"
                      onClick={() => onSendToGateway(zone)}
                    >
                      <FontAwesomeIcon icon={faPaperPlane} />
                    </button>
                    {(() => {
                      const zoneKey = zone.id;
                      const ackInfo = zoneKey != null ? zoneAckInfoByZone[String(zoneKey)] : undefined;

                      if (!ackInfo) return null;

                      let iconColor: string | undefined;
                      let clickable = false;

                      if (ackInfo.color === "Yellow") {
                        iconColor = "#cc8d00b3";
                        clickable = false;
                      } else if (ackInfo.color === "Red") {
                        iconColor = "#dc3545";
                        clickable = true;
                      }

                      if (!iconColor) return null;

                      return (
                        <button
                          type="button"
                          className={`zone-card__action zone-card__action--ack${clickable ? " cursor-pointer" : ""}`}
                          style={{ color: iconColor }}
                          title={ackInfo.statusMessage}
                          onClick={clickable ? () => onUnacknowledgedClick(zone) : undefined}
                        >
                          <FontAwesomeIcon icon={faCircleExclamation} />
                        </button>
                      );
                    })()}
                    {(() => {
                      const configurationState = zoneConfigurationStates[zone.id];
                      const isPending = configurationState?.status === "pending";

                      return (
                        <div className="zone-card__settings-action">
                          <button
                            type="button"
                            className="zone-card__action"
                            onClick={() => onSettings(zone)}
                            title={isPending ? "Waiting for configuration acknowledgement" : "Settings"}
                            disabled={isPending}
                          >
                            <FontAwesomeIcon icon={faCog} />
                          </button>
                          {configurationState && configurationState.status !== "idle" && (
                            <span className="zone-card__settings-status">
                              <ConfigurationStatusIndicator
                                status={configurationState.status}
                                countdown={configurationState.countdown}
                              />
                            </span>
                          )}
                        </div>
                      );
                    })()}
                    <button type="button" className="zone-card__action" onClick={() => onEdit(zone)} title="Edit">
                      <FontAwesomeIcon icon={faPencilAlt} />
                    </button>
                    <button
                      type="button"
                      className="zone-card__action zone-card__action--danger"
                      onClick={() => onDelete(zone)}
                      title="Delete"
                    >
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div className="zones-footer">
              <div className="zones-footer__left">
                {totalRecords > 0
                  ? `Showing ${(pageNumber - 1) * pageSize + 1}-${Math.min(pageNumber * pageSize, totalRecords)} of ${totalRecords} ${totalRecords === 1 ? "zone" : "zones"}`
                  : "No zones"}
              </div>
              <NewPaginationComponent
                totalNumberOfRecords={totalRecords}
                pageSize={pageSize}
                current={pageNumber}
                onChangePage={onPageChange}
              />
            </div>
          </>
        )}
      </SkeletonComponent>
    </div>
  );
}
